import React, { useEffect, useState } from 'react';
interface TimeLeft {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
}
export function YtJuevesCountdownTimer() {
  const [timeLeft, setTimeLeft] = useState<TimeLeft>({
    days: 0,
    hours: 0,
    minutes: 0,
    seconds: 0
  });
  useEffect(() => {
    // Thursday, January 8th, 2026 at 7:00 PM EST
    const targetDate = new Date('2026-01-08T19:00:00-05:00').getTime();
    const updateCountdown = () => {
      const now = new Date().getTime();
      const distance = targetDate - now;
      if (distance < 0) {
        setTimeLeft({
          days: 0,
          hours: 0,
          minutes: 0,
          seconds: 0
        });
        return;
      }
      setTimeLeft({
        days: Math.floor(distance / (1000 * 60 * 60 * 24)),
        hours: Math.floor(distance % (1000 * 60 * 60 * 24) / (1000 * 60 * 60)),
        minutes: Math.floor(distance % (1000 * 60 * 60) / (1000 * 60)),
        seconds: Math.floor(distance % (1000 * 60) / 1000)
      });
    };
    updateCountdown();
    const interval = setInterval(updateCountdown, 1000);
    return () => clearInterval(interval);
  }, []);
  return <div className="flex flex-col items-center space-y-4 md:space-y-6 py-6 md:py-8" data-id="element-754">
      <h3 className="text-base sm:text-lg md:text-2xl font-bold text-red-500 px-4" data-id="element-755">
        La Masterclass Comienza En:
      </h3>
      <div className="flex gap-2 sm:gap-4 md:gap-8" data-id="element-756">
        <div className="flex flex-col items-center" data-id="element-757">
          <span className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-black text-red-500" data-id="element-758">
            {String(timeLeft.days).padStart(2, '0')}
          </span>
          <span className="text-xs md:text-sm mt-1 md:mt-2 uppercase tracking-widest font-bold text-red-400" data-id="element-759">
            Días
          </span>
        </div>
        <div className="flex flex-col items-center" data-id="element-760">
          <span className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-black text-red-500" data-id="element-761">
            {String(timeLeft.hours).padStart(2, '0')}
          </span>
          <span className="text-xs md:text-sm mt-1 md:mt-2 uppercase tracking-widest font-bold text-red-400" data-id="element-762">
            Horas
          </span>
        </div>
        <div className="flex flex-col items-center" data-id="element-763">
          <span className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-black text-red-500" data-id="element-764">
            {String(timeLeft.minutes).padStart(2, '0')}
          </span>
          <span className="text-xs md:text-sm mt-1 md:mt-2 uppercase tracking-widest font-bold text-red-400" data-id="element-765">
            Min
          </span>
        </div>
        <div className="flex flex-col items-center" data-id="element-766">
          <span className="text-3xl sm:text-4xl md:text-6xl lg:text-7xl font-black text-red-500" data-id="element-767">
            {String(timeLeft.seconds).padStart(2, '0')}
          </span>
          <span className="text-xs md:text-sm mt-1 md:mt-2 uppercase tracking-widest font-bold text-red-400" data-id="element-768">
            Seg
          </span>
        </div>
      </div>
    </div>;
}